export default "__VITE_ASSET__BoPj8tjR__"